import { api } from '@forbiz/web-kit'
import type { OrgCatalogListResponse, UpdateOrgCatalogRequest } from '@forbiz/contracts'

/**
 * 조직 즐겨찾기 셀프 큐레이션 (BIZ-83). 관리자가 전역 상품에서 별표로 주문서 목록을 정한다.
 * 조회는 구성원 누구나, 변경(별표·기본)은 기업 관리자만(서버 게이트).
 */
export const orgCatalogApi = {
  list: () => api.get<OrgCatalogListResponse>('/api/my/catalog'),
  setStar: (productId: number, body: UpdateOrgCatalogRequest) =>
    api.put<{ ok: true }>(`/api/my/catalog/${productId}`, body),
  /** 전부 노출로 초기화(셀프 큐레이션 일괄 해제). */
  showAll: () => api.del<{ ok: true }>('/api/my/catalog'),
}
